export const PURCHASE_URL = `https://devsbrain.com/purchase/?item_id=54`;